import { Theme, css } from '@emotion/react';

export const sliderStyles = ({ colors }: Theme) => css`
  color: ${colors.fgPrimaryBase};
  height: 12px;
  max-width: 400px;

  .MuiSlider-thumb {
    height: 24px;
    width: 24px;
    background-color: '#fff';
    border: 2px solid currentColor;
    margin-top: -8px;
    margin-left: -12px;
    &:focus,
    &:hover,
    &:active {
      box-shadow: inherit;
    }
  }

  .MuiSlider-mark {
    display: none;
  }

  .MuiSlider-valuelabel {
    left: calc(-50% + 4px);
  }

  .MuiSlider-track,
  .MuiSlider-rail {
    height: 8px;
    border-radius: 4px;
  }
`;

export const sliderContainerStyles = ({ breakpoints }: Theme) => css`
  width: 100%;

  ${breakpoints.up('md')} {
    min-width: 300px;
  }
`;

export const sliderRightLabel = css`
  text-align: right;
`;
